import {WdiCardTitle, wdiCore, WdiModalProps} from "@/components/WdiControls";
import {ResponseStatus} from "@/utils/request";
import {useEffect, useState} from "react";
import {Enum} from "@/enums/system";
import {toExcel, ToExcelProps} from "@/components/WdiControls/WdiExcel";
import {SoldTo} from "@/services/mdm/soldto";
import {WdiPanel} from "@/components/WdiControls/WdiPanel";
import {ImportModalApp} from "@/components/WdiControls/WdiImport";
import {WdiTable} from "@/components/WdiControls/WdiTable";
import DataStore from "@/components/GridWidget/DataStore";
import {Button, message, Modal} from "antd";
import {OpenModeEnum} from "@/pages/policy/ProductPolicyApply/components/apply";
import { ExclamationCircleOutlined } from "@ant-design/icons";
const {confirm} = Modal;

export type DetailForApplyProps = {
  getProductPolicy?:  () => API.ProductPolicy,
  dataSource: API.ProductPolicyTargetVo[],
  onChange?: (dataSource: any) => void;
  openMode?: OpenModeEnum;
};

/**选择产品政策弹窗 */
export const ProductPolicyTargetForApplyPanel: React.FC<DetailForApplyProps> = (props) => {

  const [isLoaded, setIsLoaded] = useState(false);
  const [importExcels, setImportExcels] = useState<ToExcelProps[]>([]);
  const {getProductPolicy, dataSource, onChange} = props;
  const [modalProps, setModalProps] = useState<WdiModalProps>({visible: false});

  const onClose = () => {
    setModalProps({visible: false, title: "", id: null});
  }
  const onImportSave = (uploadResult: any) => {
    if (uploadResult.code == ResponseStatus.SUCCESS) {
      onChange?.(DataStore.init(uploadResult?.data?.data));
    }
    setModalProps({visible: false, title: "", id: null});
  }

  const columns: any[] = [
    {
      title: '客户',
      dataIndex: 'soldToCode',
      width: 500,
      ellipsis: true,
      render: (_value:any, record:any) => {
        return wdiCore.String.CodeOrName(record.soldToCode,record.soldToName)
      }
    },
    {
      title: '年月',
      dataIndex: 'ym',
      ellipsis: true,
      width: 300,
    },
    {
      title: '政策目标',
      dataIndex: 'target',
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.Number.AmountToString(value);
      }
    },
  ];

  const initImportExcel = () => {
    const soldToColumns = [
      {name: "soldToCode", displayName: "客户编号"},
      {name: "soldToName", displayName: "客户名称"},
      {name: "boName4", displayName: "四级使用部门"},
      {name: "boName3", displayName: "三级使用部门"},
      {name: "boName2", displayName: "二级使用部门"},
      {name: "boName1", displayName: "一级使用部门"}
    ];
    const soldToSheet = {
      dataLoading: async (params: any) => {
        return await SoldTo.queryForSheet(Object.assign({
          withPermissions: true,
          isActive: true,
          soldToLevel: 1
        }, params));
      },
      data: null,
      names: soldToColumns,
      sheetName: "客户列表",
    };
    const importExcels: ToExcelProps[] = [];
    importExcels.push({
      name: "全部下载",
      sheetProps: [soldToSheet]
    });
    importExcels.push({
      name: "客户列表",
      sheetProps: [soldToSheet]
    });
    setImportExcels(importExcels);
  }

  const exportButton = () => {
    return <a type='primary'
              onClick={(e) => {
                const exportColumns = [
                  {name: 'soldToCode', displayName: '客户编号'},
                  {name: 'soldToName', displayName: '客户名称'},
                  {name: 'ym', displayName: '年月'},
                  {name: 'target', displayName: '政策目标'},
                ]
                const sheet = {
                  data: dataSource,
                  names: exportColumns,
                  sheetName: "政策目标",
                };
                toExcel({
                  name: "政策目标" + wdiCore.Date.ToString(new Date()) + ".xlsx",
                  sheetProps: [sheet]
                })
                e.stopPropagation();
              }}
              style={{float: 'right', marginRight: 10}}
    >
      导出
    </a>
  }


  const importButton = () => {
    return <a
      type='primary'
      onClick={(e) => {
        const productPolicy = getProductPolicy?.();
        if(!productPolicy?.startDate || !productPolicy?.endDate){
          message.error("政策期间不能为空!");
          return;
        }
        if(!productPolicy?.bohqId){
          message.error("预算归属不能为空!");
          return;
        }
        setModalProps({title: '政策目标导入', visible: true});
        e.stopPropagation();
      }}
      style={{float: 'right', marginRight: 10}}>
      导入
    </a>
  }

  const cleanButton = () => {
    return <a
      type='primary'
      onClick={() => {
        confirm({
          title: '确认要清除列表的数据内容吗？',
          icon: <ExclamationCircleOutlined/>,
          onOk() {
            onChange?.([])
            message.success("清除成功")
          },
        });
      }}
      style={{float: 'right', marginRight: 10}}
    >
      清空
    </a>
  }

  const getOperations = () => {
    return <>
      {importButton()}
      {cleanButton()}
      {exportButton()}
    </>
  }

  useEffect(() => {
    initImportExcel();
    setIsLoaded(true);
  }, [props]);


  return (
    <>
      <WdiPanel
        title={<WdiCardTitle iconType={Enum.IconType.BASE_INFO} title={'政策目标'}/>}
        collapsed={true}
        extra={getOperations()}
      >
        {isLoaded && modalProps.visible &&
          <ImportModalApp
            title={modalProps.title}
            visible={modalProps.visible}
            settingsUrl="/expenseapi/productPolicy/getTargetImportSettings"
            uploadingUrl="/expenseapi/productPolicy/targetImportUploading"
            onClose={onClose}
            onSave={onImportSave}
            clientParameters={{
              formPolicyTargets: JSON.stringify(dataSource),
              productPolicy: getProductPolicy?.(),
              openMode: props.openMode
            }}
            importExcels={importExcels}
          />
        }
        {
          isLoaded &&
          <WdiTable
            pagination={{defaultPageSize: 10,}}
            columns={columns}
            dataSource={dataSource}
          />
        }
      </WdiPanel>
      <br/>
    </>
  );
};

export const ProductPolicyTargetForApprovalPanel: React.FC<DetailForApplyProps> = (props) => {
  const {dataSource} = props;

  const columns: any = [
    {
      title: '客户',
      dataIndex: 'soldToCode',
      width: 500,
      ellipsis: true,
      render: (_value:any, record:any) => {
        return wdiCore.String.CodeOrName(record.soldToCode,record.soldToName)
      }
    },
    {
      title: '年月',
      dataIndex: 'ym',
      ellipsis: true,
      width: 200,
    },
    {
      title: '政策目标',
      dataIndex: 'target',
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.Number.AmountToString(value);
      }
    },
    {
      title: '创建人',
      dataIndex: 'createdUserName',
      width: 150,
      ellipsis: true,
    },
    {
      title: '创建时间',
      dataIndex: 'createdDate',
      width: 200,
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.Date.MinuteToString(value);
      }
    },
    {
      title: '修改人',
      dataIndex: 'modifiedUserName',
      width: 150,
      ellipsis: true,
    },
    {
      title: '修改时间',
      dataIndex: 'modifiedDate',
      width: 200,
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.Date.MinuteToString(value);
      }
    },
  ];

  return (
    <>
      <WdiPanel
        title={<WdiCardTitle iconType={Enum.IconType.BASE_INFO} title={'政策目标'}/>}
        collapsed={true}
        extra={
          <>
            {
              <>
                <Button
                  style={{float: 'right'}}
                  type='primary'
                  onClick={(e) => {
                    const columns = [
                      {name: 'soldToCode', displayName: '客户编号'},
                      {name: "soldToName", displayName: "客户名称"},
                      {name: "ym", displayName: "年月"},
                      {name: "target", displayName: "政策目标"},
                    ];
                    columns.push({name: 'createdUserName', displayName: '创建人'});
                    columns.push({name: 'createdDate', displayName: '创建时间'});
                    columns.push({name: 'modifiedUserName', displayName: '修改人'});
                    columns.push({name: 'modifiedDate', displayName: '修改时间'});
                    const sheet = {
                      data: dataSource,
                      names: columns,
                      sheetName: "政策目标导出",
                    };
                    toExcel({
                      name: "政策目标导出" + wdiCore.Date.ToString(new Date()) + ".xlsx",
                      sheetProps: [sheet]
                    })
                    e.stopPropagation();
                  }}
                > 导出 </Button>
              </>
            }
          </>
        }
      >
        <WdiTable
          pagination={{defaultPageSize: 10,}}
          columns={columns}
          dataSource={dataSource}
        />
      </WdiPanel>
      <br/>
    </>
  );
};
